export const iconDictionary = {
  info: 'uiInfoCircle',
  warning: 'uiExclamationTriangle',
  error: 'uiExclamationTriangle',
  success: 'uiCheckCircle',
}

export const spacingDictionary = {
  sm: 6,
  md: 8,
  lg: 10,
}

export const messageColors = {
  info: 'seaBlue.main',
  warning: 'terracotta.30',
  error: 'energyRed.45',
  success: 'landGreen.35',
}

export const avatarStyles = {
  mt: '4px',
  color: 'black',
}
